const POSPrint = ({
  tabletMode,
  cart,
  reciptDetails,
  totalPrice,
  orderType,
  orderId,
  mobile,
  tenderedAmount,
  selectedDiscount,
  apiResponsePrint,
}) => {
  const handlePrintAPI = (reciptDetails, item) => {
    let formattedAddress = "Not available";

    try {
      const addressObj = JSON.parse(item.address_json);
      const values = addressObj?.values || {};

      formattedAddress = [
        values.name,
        values.house_number,
        values.address,
        values.landmark_area,
        values.city,
        values.state,
        values.in_pin_code,
        `Ph: ${values.phone_number}`,
      ]
        .filter(Boolean)
        .join(", ")
        .replace(/,/g, ",&nbsp;");
    } catch (error) {
      console.error("Failed to parse address_json:", error);
    }

    const singleReceiptSection = `
      <div class="container">
        <div class="header">
          <p class="textSizeLarge" style="font-weight:600;">${reciptDetails.business_name}</p>
          <p class="textSizeMid">${reciptDetails.address}</p>
          <p class="textSizeMid">PH: ${reciptDetails.phone_no}</p>
          <p class="textSizeMid">GST NO: ${reciptDetails.gst}</p>
          ${reciptDetails.fssaiNo
        ? `<p class="textSizeMid">FSSAI NO: ${reciptDetails.fssaiNo}</p>`
        : ""
      }
          <p class="textSizeLarge" style="font-weight:600;">** INVOICE **</p>
        </div>

        <div class="header2">
          <p class="textSizeMid">Order No: ${item.daily_order_id} / ${item.orderid}</p>
          <p class="textSizeMid">Order Type: ${item.orderType}</p>

          ${!(
        item.customer_name?.toLowerCase() === "default" &&
        ["+91 9999999999", "+91999999999", "91999999999", "999999999"].includes(
          item.customer_mobile
        )
      )
        ? `
              <p class="textSizeMid">Customer Name: ${item.customer_name}</p>
              <p class="textSizeMid">Customer Mobile: ${item.customer_mobile}</p>
            `
        : ""
      }

          ${item.billingName
        ? `<p class="textSizeMid">Billing Name: ${item.billingName}</p>`
        : ""
      }

          ${item.billingGst
        ? `<p class="textSizeMid">Billing GST: ${item.billingGst}</p>`
        : ""
      }

          ${item.billingAddress
        ? `<p class="textSizeMid">Billing Address: ${item.billingAddress}</p>`
        : ""
      }

          <p class="textSizeMid">Payment Status: ${item.payment_status}</p>
          <p class="textSizeMid">Payment Mode: ${item.payment_mode}</p>
          <p class="textSizeMid">Order Date: ${item.order_date}</p>

          ${item.orderType === "homedelivery"
        ? `<p class="textSizeMid">Delivery Address: ${formattedAddress}</p>`
        : ""
      }

          ${item.orderType === "dining"
        ? `<p class="textSizeMid">Table No: ${item.table_no}</p>`
        : ""
      }

          ${item.orderType === "room_order"
        ? `<p class="textSizeMid">Room No: ${item.table_no}</p>`
        : ""
      }
        </div>

        <div class="headerTable">
          <table class="order-details">
            <thead>
              <tr>
                <th class="table-text-center">Sr</th>
                <th class="table-text-center">Item</th>
                <th class="table-text-center">Qty</th>
                <th class="table-text-center">Price</th>
                <th class="table-text-center">Total</th>
              </tr>
            </thead>
            <tbody>
              ${item.items
        .map((subitem, index) => {
          let customizationText = "";
          try {
            const customization =
              subitem.customization && subitem.customization !== "{}"
                ? JSON.parse(subitem.customization)
                : null;

            if (Array.isArray(customization)) {
              customizationText = customization
                .map((c) => c.options?.join(", "))
                .filter(Boolean)
                .join(" | ");
              customizationText = customizationText
                ? `<div class="custom-text">(${customizationText})</div>`
                : "";
            }
          } catch { }

          return `
                    <tr>
                      <td class="table-text-center">${index + 1}</td>
                      <td>${subitem.item_name}${customizationText}</td>
                      <td class="table-text-center">${subitem.quantity}</td>
                      <td class="table-text-center">${Number(subitem.item_price)}</td>
                      <td class="table-text-center">${Number(subitem.total_price)}</td>
                    </tr>
                  `;
        })
        .join("")}
            </tbody>
          </table>
        </div>

        <div class="headerTotal">
          <div class="flex-row">
            <p class="textSizeMid">Sub Total</p>
            <p class="textSizeMid">Rs. ${item.subtotal}</p>
          </div>

          ${item.discount_amount !== "0.00"
        ? `
              <div class="flex-row">
                <p class="textSizeMid">Discount (${item.discount_percentage}%)</p>
                <p class="textSizeMid">Rs. ${Number(item.discount_amount).toFixed(2)}</p>
              </div>`
        : ""
      }

          ${Number(reciptDetails.taxCgst) > 0
        ? `
              <div class="flex-row">
                <p class="textSizeMid">CGST</p>
                <p class="textSizeMid">Rs. ${Number(item.tax_cgst).toFixed(2)}</p>
              </div>`
        : ""
      }

          ${Number(reciptDetails.taxSgst) > 0
        ? `
              <div class="flex-row">
                <p class="textSizeMid">SGST</p>
                <p class="textSizeMid">Rs. ${Number(item.tax_sgst).toFixed(2)}</p>
              </div>`
        : ""
      }

          <div class="flex-row" style="font-weight:600;">
            <p class="textSizeMid">Total</p>
            <p class="textSizeMid">Rs. ${item.totalOrderPrice}</p>
          </div>
        </div>

        <div class="headerEnd">
          <p class="textSizeMid">Thank you for your purchase!</p>
          <p class="textSizeSmall">* ${reciptDetails.tag_line1} *</p>
        </div>
      </div>
    `;

    const printHTML = `
      <html>
        <head>
          <style>
            @page { size: 80mm; margin: 0; }
            body { margin:0; font-family: Arial; }
            .header,.header2,.headerTable,.headerTotal { border-bottom:1px dashed #000; }
            .flex-row { display:flex; justify-content:space-between; }
            .textSizeLarge { font-size:16px; }
            .textSizeMid { font-size:12px; }
            .textSizeSmall { font-size:9px; }
            table { width:100%; border-collapse:collapse; }
            th,td { padding:4px; font-size:12px; }
            .table-text-center { text-align:center; }
          </style>
        </head>
        <body>
          ${singleReceiptSection}
        </body>
      </html>
    `;

    const printWindow = window.open("", "_blank");
    printWindow.document.write(printHTML);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  return (
    <button
      onClick={() => {
        if (Array.isArray(apiResponsePrint) && apiResponsePrint.length > 0) {
          handlePrintAPI(reciptDetails, apiResponsePrint[0]);
        } else if (apiResponsePrint && typeof apiResponsePrint === "object") {
          handlePrintAPI(reciptDetails, apiResponsePrint);
        }
      }}
      style={{ height: "120px", width: "250px" }}
      className={
        tabletMode
          ? "vm-tablet-button scale-button shadow border rounded"
          : "scale-button shadow border rounded fs-4 fw-bold"
      }
    >
      PRINT
    </button>
  );
};

export default POSPrint;

